<template>
  <div v-if="isVisible">
    <object-model-entry-form-field
      v-if="isEditableProperty"
      :object-model="contentElement.objectModel"
      :objectModelEntry="entry"
      :label-title="contentElement.label_title"
      :is-detail-view-edit="true"
      :format-as-percentage="formatAsPercentage"
      :property-client-id="contentElement.property.client_id"
      @queue-upload-for-deletion="$emit('queue-upload-for-deletion', $event)"
    ></object-model-entry-form-field>

    <template v-else>
      <help-tooltip v-if="shouldShowToolTip"
        :text="toolTipText"
      ></help-tooltip>

      <detail-view-content-element-base
        :key="contentElement.id"
        :is-in-edit-mode="true"
        :content-element="contentElement"
        :entry="entry"
      >
      </detail-view-content-element-base>
    </template>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import DetailViewContentElementDefinition from "~/models/detailView/elements/detailViewContentElementDefinition";
import { DetailViewContentElementType } from "~/enums/detailViews/detailViewContentElementType";
import DetailViewContentElement from "~/models/detailView/elements/detailViewContentElement";
import ObjectModelEntry from "~/models/objectModelEntries/objectModelEntry";
import { DetailViewContentElementCapability } from "~/models/detailView/elements/detailViewContentElementCapability";
import ObjectModelEntryFormField from "~/components/objectModelEntry/object-model-entry-form-field.vue";
import ModelProperty from "../../detailViewBuilder/models/modelProperty";
import ObjectModelConditionalRuleEvaluator from "~/models/objectModels/objectModelConditionalRuleEvaluator";
import {InputFormatType} from "../../form_builder/models/inputFormatType";

export default Vue.extend({
  name: "detail-view-edit-element-base",
  mixins: [],
  components: {
    ObjectModelEntryFormField,
  },
  props: {
    contentElement: {
      type: Object as () => DetailViewContentElement,
    },
    entry: {
      type: Object as () => ObjectModelEntry,
    },
    showingAllAttachments: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      DetailViewContentElementCapability,
      DetailViewContentElementType,
    };
  },
  computed: {
    isEditableProperty(): boolean {
      return (
        this.contentElement instanceof ModelProperty &&
        !this.contentElement.builtinPropertyType &&
        !this.contentElement.isNestedReference
      );
    },
    isVisible(): boolean {
      return ObjectModelConditionalRuleEvaluator.evaluate(this.entry, this.contentElement, "visible");
    },
    formatAsPercentage(): boolean {
      return this.contentElement.format_type === InputFormatType.Percentage;
    },
    shouldShowToolTip(): boolean {
      return this.contentElement.isNestedReference
    },
    toolTipText(): string {
      if (this.contentElement.isReferenceObjectModelRelation) return "This value is pulled from an account and cannot be edited."
      return "This value is pulled from another record and cannot be edited here. Edits can be made on the related record."
    }
  },
  methods: {
    getComponentByType(contentType: DetailViewContentElementType): string {
      return DetailViewContentElementDefinition.getComponent(contentType);
    },
    getComponentClass(contentType: DetailViewContentElementType): string {
      return DetailViewContentElementDefinition.getComponentClass(contentType);
    },
  },
});
</script>